import * as tslib_1 from "tslib";
import { suggestionSelected } from '../actions/publicActions';
import { CLICK_ACTION_SOURCE } from '../searchConstants';
import { getStore } from '../store/store';
import { observer } from 'mobx-react';
import { CategoryIcon } from 'owa-categories';
import * as React from 'react';
var styles = require('./SuggestionsContextMenu.scss');
var CategorySuggestionMenuItem = /** @class */ (function (_super) {
    tslib_1.__extends(CategorySuggestionMenuItem, _super);
    function CategorySuggestionMenuItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CategorySuggestionMenuItem.prototype.render = function () {
        var suggestion = this.props.suggestion;
        var categoryName = suggestion.Name;
        var searchText = getStore().searchTextForSuggestion;
        var matchText = '';
        var nonMatchText = categoryName;
        if (categoryName.toLocaleLowerCase().indexOf(searchText.toLocaleLowerCase()) == 0) {
            matchText = categoryName.substr(0, searchText.length);
            nonMatchText = categoryName.substr(searchText.length, categoryName.length - 1);
        }
        return (React.createElement("div", { className: styles.keywordSuggestion, key: suggestion.ReferenceId, tabIndex: 0, 
            // VSO:17221 as a part of 17221, we should change onMouseDown to onClick
            onMouseDown: function () {
                suggestionSelected(suggestion, CLICK_ACTION_SOURCE);
            } },
            React.createElement(CategoryIcon, { categoryName: categoryName, iconClassName: styles.suggestionCategoryIcon }),
            React.createElement("span", { className: styles.keywordMatchSuggestion }, matchText),
            React.createElement("span", { className: styles.keywordNonMatchSuggestion }, nonMatchText)));
    };
    CategorySuggestionMenuItem = tslib_1.__decorate([
        observer
    ], CategorySuggestionMenuItem);
    return CategorySuggestionMenuItem;
}(React.Component));
export default CategorySuggestionMenuItem;
//# sourceMappingURL=CategorySuggestionMenuItem.js.map